import { InstagramTheme } from '@/components/Instagram/theme';
import { GenericSlotFactory } from 'base/components/GenericSlot';

const $ = GenericSlotFactory({ theme: InstagramTheme });

const Base = $({ as: 'div' });

export const Instagram = Base;
